// Helper that reliably opens external URLs in a new tab,
// bypassing iframe sandboxes (Emergent preview) when possible.
export function openExternal(url) {
  try {
    const w = window.open(url, "_blank", "noopener,noreferrer");
    if (w) return;
  } catch (e) {
    // ignore
  }
  // Fallbacks for sandboxed iframes
  try {
    if (window.top && window.top !== window.self) {
      window.top.location.href = url;
      return;
    }
  } catch (e) {
    // cross-origin frame, fall through
  }
  window.location.href = url;
}
